export interface Chapter {
  num: number;
  title: string;
  updateTime: string;
  readCount: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  status: "连载中" | "已完结" | "新上架";
  categories: string[];
  tags: string[];
  rating: number;
  views: string;
  favorites: string;
  description: string;
  latestChapter: string;
  updateTime: string;
  totalChapters: string;
  isHot?: boolean;
  isNew?: boolean;
  chapters: Chapter[];
}

export const categories = [
  "热血冒险",
  "奇幻异能",
  "悬疑推理",
  "科幻机甲",
  "萌系日常",
  "武侠仙侠",
  "都市生活",
  "校园恋爱",
];

export const comics: Comic[] = [
  {
    id: "xinggui-shaonian",
    title: "星轨少年",
    author: "蓝汐",
    cover: "https://readdy.ai/api/search-image?query=manga%20cover%20illustration%20of%20a%20brave%20teenage%20boy%20holding%20a%20glowing%20star%20scepter%2C%20starry%20deep%20space%20background%20with%20planet%20rings%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20dynamic%20action%20pose%2C%20clean%20bold%20lineart%2C%20vibrant%20anime%20style%2C%20high%20contrast%20lighting&width=440&height=600&seq=comic-xinggui&orientation=portrait",
    status: "连载中",
    categories: ["热血冒险", "科幻机甲"],
    tags: ["星际冒险", "成长", "燃向"],
    rating: 9.2,
    views: "1286.4万",
    favorites: "45.2万",
    description: "在星际联邦的边缘，少年林朔意外觉醒古老的星轨之力。为寻找失踪的父亲，他与伙伴们驾驶旧飞船踏上穿越银河的旅程，一路结识盟友、直面星际海盗与神秘文明。当星轨的秘密逐渐揭晓，一场横跨星海的宿命之战悄然开启。",
    latestChapter: "第186话 星门彼岸",
    updateTime: "2小时前",
    totalChapters: "186话",
    isHot: true,
    chapters: [
      { num: 186, title: "星门彼岸", updateTime: "2小时前", readCount: 128456 },
      { num: 185, title: "崩塌的星环", updateTime: "昨天", readCount: 120398 },
      { num: 184, title: "觉醒的辉光", updateTime: "3天前", readCount: 118905 },
      { num: 183, title: "父亲的录音", updateTime: "6天前", readCount: 112340 },
    ],
  },
  {
    id: "jianqi-changge",
    title: "剑气长歌",
    author: "墨砚",
    cover: "https://readdy.ai/api/search-image?query=manga%20cover%20of%20a%20wuxia%20swordsman%20in%20flowing%20white%20robes%20holding%20a%20sword%2C%20ink%20wash%20painting%20style%20with%20misty%20mountains%20and%20falling%20petals%2C%20elegant%20chinese%20martial%20arts%20fantasy%2C%20soft%20beige%20and%20deep%20ink%20black%20palette%2C%20dramatic%20composition&width=440&height=600&seq=comic-jianqi&orientation=portrait",
    status: "连载中",
    categories: ["武侠仙侠", "热血冒险"],
    tags: ["江湖", "剑道", "侠义"],
    rating: 9.4,
    views: "892.7万",
    favorites: "38.9万",
    description: "少年沈剑一出生便背负家族血仇，被名剑阁长老收入门下。从一柄无名铁剑开始，他闯荡江湖、磨砺剑心，在正邪交织的乱世中探寻剑道真谛。江湖恩怨、门派纷争与隐藏百年的秘密，终将在剑光中一一揭晓。",
    latestChapter: "第142话 剑心明镜",
    updateTime: "5小时前",
    totalChapters: "142话",
    isHot: true,
    chapters: [
      { num: 142, title: "剑心明镜", updateTime: "5小时前", readCount: 98720 },
      { num: 141, title: "雾隐渡口", updateTime: "昨天", readCount: 94310 },
      { num: 140, title: "裂空的剑光", updateTime: "2天前", readCount: 92081 },
      { num: 139, title: "旧仇新恨", updateTime: "5天前", readCount: 88450 },
    ],
  },
  {
    id: "wudu-zhentanshe",
    title: "雾都侦探社",
    author: "灰影",
    cover: "https://readdy.ai/api/search-image?query=manga%20cover%20of%20a%20noir%20detective%20silhouette%20with%20trench%20coat%20and%20hat%2C%20foggy%20rainy%20city%20skyline%20at%20night%2C%20mysterious%20atmosphere%2C%20muted%20teal%20and%20amber%20streetlight%20tones%2C%20suspense%20thriller%20style%2C%20dramatic%20shadows%20and%20mist&width=440&height=600&seq=comic-wudu&orientation=portrait",
    status: "已完结",
    categories: ["悬疑推理", "都市生活"],
    tags: ["推理", "烧脑", "反转"],
    rating: 9.1,
    views: "1640.9万",
    favorites: "52.7万",
    description: "常年被浓雾笼罩的江城，一家不起眼的侦探社专接那些「警局无能为力」的案件。侦探陆离凭借缜密观察力与直觉，与搭档一步步揭开迷雾背后的真相。每一个案件背后，都藏着人性的幽微与城市不为人知的秘密。",
    latestChapter: "第98话 真相大白（完结）",
    updateTime: "1周前",
    totalChapters: "98话",
    chapters: [
      { num: 98, title: "真相大白（完结）", updateTime: "1周前", readCount: 156340 },
      { num: 97, title: "雾散之前", updateTime: "2周前", readCount: 148920 },
      { num: 96, title: "失踪的目击者", updateTime: "3周前", readCount: 140110 },
      { num: 95, title: "迷雾迷局", updateTime: "1个月前", readCount: 135880 },
    ],
  },
  {
    id: "jiajia-jiyuan",
    title: "机甲纪元",
    author: "铁匠铺",
    cover: "https://readdy.ai/api/search-image?query=manga%20cover%20of%20a%20giant%20mecha%20robot%20standing%20in%20a%20battle%20pose%2C%20fiery%20explosion%20background%2C%20sci-fi%20military%20robots%2C%20metallic%20red%20and%20charcoal%20grey%20color%20scheme%2C%20dynamic%20angle%2C%20detailed%20mechanical%20design%2C%20high%20energy%20epic%20anime%20style&width=440&height=600&seq=comic-jiajia&orientation=portrait",
    status: "连载中",
    categories: ["科幻机甲", "热血冒险"],
    tags: ["机甲", "战争", "热血"],
    rating: 9.0,
    views: "731.2万",
    favorites: "26.4万",
    description: "近未来地球资源枯竭，人类将目光投向深空与海底。少年何远加入机动特战队，驾驶老旧试验机甲踏上战场。在一次次生死交锋中，他逐渐领悟机甲的真正意义——不是武器，而是守护所爱的力量。",
    latestChapter: "第208话 最后的防线",
    updateTime: "1小时前",
    totalChapters: "208话",
    isHot: true,
    chapters: [
      { num: 208, title: "最后的防线", updateTime: "1小时前", readCount: 142018 },
      { num: 207, title: "风暴中的引擎", updateTime: "昨天", readCount: 135700 },
      { num: 206, title: "叛逃者", updateTime: "3天前", readCount: 131280 },
      { num: 205, title: "机甲之心", updateTime: "5天前", readCount: 127940 },
    ],
  },
  {
    id: "maoka-wuyu",
    title: "猫咖物语",
    author: "软软团子",
    cover: "https://readdy.ai/api/search-image?query=cute%20manga%20cover%20of%20a%20cozy%20cat%20cafe%20with%20several%20adorable%20fluffy%20cats%20on%20windowsills%20and%20tables%2C%20warm%20pastel%20cream%20and%20milk%20tea%20tones%2C%20soft%20sketch%20lineart%2C%20relaxing%20healing%20slice%20of%20life%20style%2C%20kawaii%20chibi%20details&width=440&height=600&seq=comic-maoka&orientation=portrait",
    status: "已完结",
    categories: ["萌系日常", "都市生活"],
    tags: ["治愈", "萌宠", "日常"],
    rating: 9.3,
    views: "2058.3万",
    favorites: "61.5万",
    description: "失业的年轻女孩小满回到家乡，接手了外婆留下的旧猫咖。在十只性格迥异的猫咪陪伴下，她一点点修复店铺、结识新朋友，也慢慢疗愈自己的心。温暖的日常里，藏着关于生活、友情与成长的小小奇迹。",
    latestChapter: "第120话 常来坐坐（完结）",
    updateTime: "2周前",
    totalChapters: "120话",
    chapters: [
      { num: 120, title: "常来坐坐（完结）", updateTime: "2周前", readCount: 176420 },
      { num: 119, title: "橘座的生日", updateTime: "3周前", readCount: 169800 },
      { num: 118, title: "雨天的老顾客", updateTime: "1个月前", readCount: 162300 },
      { num: 117, title: "新来的小黑猫", updateTime: "1个月前", readCount: 158720 },
    ],
  },
  {
    id: "shenyu-zhengtu",
    title: "神域征途",
    author: "星辰画师",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20manga%20cover%20of%20a%20young%20heroine%20with%20flowing%20magical%20hair%20summoning%20golden%20light%20spirits%2C%20ancient%20floating%20ruins%20and%20mythical%20creatures%20in%20background%2C%20lavender%20and%20gold%20palette%20with%20ethereal%20glow%2C%20epic%20high%20fantasy%20adventure%20style&width=440&height=600&seq=comic-shenyu&orientation=portrait",
    status: "连载中",
    categories: ["奇幻异能", "热血冒险"],
    tags: ["异世界", "魔法", "冒险"],
    rating: 8.9,
    views: "982.6万",
    favorites: "33.8万",
    description: "普通高中生苏念在一场流星雨后，意外被卷入通往神域的大门。在这里，她觉醒独一无二的元素异能，结识了各怀秘密的伙伴。为了寻回回家的路，也为了守护神域的和平，她踏上充满奇遇与挑战的征途。",
    latestChapter: "第176话 神域的黄昏",
    updateTime: "4小时前",
    totalChapters: "176话",
    isNew: true,
    chapters: [
      { num: 176, title: "神域的黄昏", updateTime: "4小时前", readCount: 118760 },
      { num: 175, title: "元素共鸣", updateTime: "昨天", readCount: 112340 },
      { num: 174, title: "失落的圣殿", updateTime: "4天前", readCount: 109880 },
      { num: 173, title: "星门之约", updateTime: "1周前", readCount: 103250 },
    ],
  },
  {
    id: "dushi-yexing",
    title: "都市夜行",
    author: "拾荒者",
    cover: "https://readdy.ai/api/search-image?query=urban%20manga%20cover%20of%20a%20young%20man%20in%20a%20hoodie%20walking%20through%20neon%20lit%20city%20street%20at%20midnight%2C%20reflective%20rain%20on%20pavement%2C%20cool%20cyan%20and%20warm%20pink%20neon%20glow%2C%20atmospheric%20modern%20noir%20style%2C%20suspenseful%20and%20stylish&width=440&height=600&seq=comic-dushi&orientation=portrait",
    status: "连载中",
    categories: ["都市生活", "悬疑推理"],
    tags: ["都市", "异能", "群像"],
    rating: 8.7,
    views: "654.1万",
    favorites: "21.3万",
    description: "当城市入夜，白昼里循规蹈矩的人们褪去伪装。青年程野白天是普通职员，夜里却以「夜行」之名游走于都市阴影，调查那些白天无法解决的怪事。霓虹之下，每个人都在寻找属于自己的答案。",
    latestChapter: "第94话 霓虹下的真相",
    updateTime: "8小时前",
    totalChapters: "94话",
    chapters: [
      { num: 94, title: "霓虹下的真相", updateTime: "8小时前", readCount: 76420 },
      { num: 93, title: "午夜电台", updateTime: "昨天", readCount: 72110 },
      { num: 92, title: "失踪的出租车", updateTime: "4天前", readCount: 69870 },
      { num: 91, title: "路灯下的影子", updateTime: "6天前", readCount: 67240 },
    ],
  },
  {
    id: "jinji-senlin",
    title: "禁忌森林",
    author: "夜鸦",
    cover: "https://readdy.ai/api/search-image?query=horror%20manga%20cover%20of%20a%20dense%20dark%20forest%20with%20glowing%20eyes%20between%20twisted%20trees%2C%20fog%20and%20moonlight%20breaking%20through%20branches%2C%20eerie%20dark%20green%20and%20deep%20shadow%20palette%2C%20mysterious%20ominous%20atmosphere%2C%20detailed%20ink%20linework&width=440&height=600&seq=comic-jinji&orientation=portrait",
    status: "已完结",
    categories: ["悬疑推理", "奇幻异能"],
    tags: ["惊悚", "克苏鲁", "氛围"],
    rating: 8.8,
    views: "1120.5万",
    favorites: "40.6万",
    description: "村外那片被列为禁忌的森林，百年间吞噬了无数闯入者。年轻记者为调查失踪案深入其中，却发现森林深处藏着一个超越人类认知的世界。当迷雾散去，禁忌之下的真相远比想象更令人战栗。",
    latestChapter: "第66话 森林醒来（完结）",
    updateTime: "3周前",
    totalChapters: "66话",
    chapters: [
      { num: 66, title: "森林醒来（完结）", updateTime: "3周前", readCount: 134560 },
      { num: 65, title: "光的另一面", updateTime: "1个月前", readCount: 128930 },
      { num: 64, title: "祭坛", updateTime: "1个月前", readCount: 121480 },
      { num: 63, title: "树下的低语", updateTime: "2个月前", readCount: 115200 },
    ],
  },
  {
    id: "weilei-zhanji",
    title: "味蕾战记",
    author: "烟火食堂",
    cover: "https://readdy.ai/api/search-image?query=culinary%20manga%20cover%20of%20a%20passionate%20young%20chef%20with%20spatula%20beside%20steaming%20delicious%20dishes%2C%20dynamic%20flames%20and%20ingredients%20flying%2C%20warm%20red%20and%20gold%20color%20palette%2C%20energetic%20gourmet%20battle%20style%2C%20mouth%20watering%20food%20illustration&width=440&height=600&seq=comic-weilei&orientation=portrait",
    status: "连载中",
    categories: ["热血冒险", "都市生活"],
    tags: ["美食", "竞技", "治愈"],
    rating: 8.6,
    views: "543.8万",
    favorites: "18.9万",
    description: "为继承外婆的小饭馆，少女林小满决定参加全国厨艺大赛。从一个只会做家常菜的新人开始，她在味蕾的战场上挑战各路名厨，用最普通的食材创造最动人的味道。美食背后，是对家人与梦想的执着守护。",
    latestChapter: "第78话 家乡的味道",
    updateTime: "6小时前",
    totalChapters: "78话",
    isNew: true,
    chapters: [
      { num: 78, title: "家乡的味道", updateTime: "6小时前", readCount: 64530 },
      { num: 77, title: "对手登场", updateTime: "昨天", readCount: 60120 },
      { num: 76, title: "决赛前夜", updateTime: "3天前", readCount: 57840 },
      { num: 75, title: "意外的评委", updateTime: "5天前", readCount: 54990 },
    ],
  },
  {
    id: "xingji-kuadiyuan",
    title: "星际快递员",
    author: "太空邮差",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20manga%20cover%20of%20a%20cheerful%20young%20courier%20holding%20a%20space%20parcel%20with%20rocket%20jetpack%2C%20colorful%20space%20station%20background%2C%20bright%20orange%20and%20sky%20blue%20palette%2C%20playful%20comedy%20adventure%20style%2C%20clean%20cartoon%20lineart&width=440&height=600&seq=comic-kuadi&orientation=portrait",
    status: "连载中",
    categories: ["科幻机甲", "萌系日常"],
    tags: ["星际", "搞笑", "日常"],
    rating: 8.5,
    views: "487.3万",
    favorites: "16.7万",
    description: "在银河快递公司，快递员阿达每天要穿越星际为各种奇奇怪怪的客户送货。他的包裹可能是宠物小怪兽，也可能是失窃的星球核心。每一次送件都是一场啼笑皆非的冒险，而阿达也渐渐发现了快递背后的温情故事。",
    latestChapter: "第152话 银河大促",
    updateTime: "3小时前",
    totalChapters: "152话",
    chapters: [
      { num: 152, title: "银河大促", updateTime: "3小时前", readCount: 58230 },
      { num: 151, title: "会说话的包裹", updateTime: "昨天", readCount: 54210 },
      { num: 150, title: "星际迷航", updateTime: "4天前", readCount: 51870 },
      { num: 149, title: "神秘收货人", updateTime: "6天前", readCount: 49540 },
    ],
  },
  {
    id: "shijian-lvguan",
    title: "时间旅馆",
    author: "钟表匠",
    cover: "https://readdy.ai/api/search-image?query=magical%20manga%20cover%20of%20a%20mysterious%20old%20hotel%20with%20giant%20clock%20tower%2C%20a%20young%20manager%20at%20reception%2C%20warm%20golden%20and%20deep%20brown%20palette%2C%20time%20travel%20concept%2C%20whimsical%20fantasy%20atmosphere%2C%20soft%20storybook%20illustration%20style&width=440&height=600&seq=comic-lvguan&orientation=portrait",
    status: "新上架",
    categories: ["奇幻异能", "悬疑推理"],
    tags: ["时间", "温情", "奇幻"],
    rating: 9.0,
    views: "12.6万",
    favorites: "1.2万",
    description: "城郊一座看似普通的旅馆，实则住着来自不同时间线的旅人。年轻的旅馆掌柜周逸负责接待这些时空过客，倾听他们各自的故事。在交错的时间河流中，他逐渐明白——有些遗憾，或许可以再见面。",
    latestChapter: "第12话 逆流的信",
    updateTime: "刚刚",
    totalChapters: "12话",
    isNew: true,
    isHot: true,
    chapters: [
      { num: 12, title: "逆流的信", updateTime: "刚刚", readCount: 8340 },
      { num: 11, title: "1957年的房客", updateTime: "昨天", readCount: 7920 },
      { num: 10, title: "时间的裂缝", updateTime: "4天前", readCount: 7300 },
      { num: 9, title: "候鸟旅人", updateTime: "6天前", readCount: 6810 },
    ],
  },
  {
    id: "shanhai-shitang",
    title: "山海食堂",
    author: "云中客",
    cover: "https://readdy.ai/api/search-image?query=chinese%20fantasy%20manga%20cover%20of%20a%20food%20stall%20with%20steaming%20bowls%20and%20mythical%20beasts%20as%20customers%2C%20ink%20and%20warm%20cinnabar%20red%20palette%2C%20classical%20chinese%20mythology%20atmosphere%2C%20cozy%20monster%20chef%20story%2C%20elegant%20traditional%20art%20style&width=440&height=600&seq=comic-shanhai&orientation=portrait",
    status: "新上架",
    categories: ["奇幻异能", "武侠仙侠"],
    tags: ["山海经", "美食", "神话"],
    rating: 8.9,
    views: "9.8万",
    favorites: "0.9万",
    description: "山海之间有一间只在夜间开张的食堂，接待的客人都是传说里的灵兽仙妖。年轻的掌勺人以美食为媒，帮助每一位客人解开心结。从饕餮到九尾狐，一顿饭的时间，足以讲述一段山海传奇。",
    latestChapter: "第8话 饕餮的胃口",
    updateTime: "2小时前",
    totalChapters: "8话",
    isNew: true,
    chapters: [
      { num: 8, title: "饕餮的胃口", updateTime: "2小时前", readCount: 6010 },
      { num: 7, title: "九尾狐的约定", updateTime: "昨天", readCount: 5690 },
      { num: 6, title: "夜访的仙人", updateTime: "3天前", readCount: 5200 },
      { num: 5, title: "山神的烦恼", updateTime: "5天前", readCount: 4890 },
    ],
  },
  {
    id: "xueyuan-yinengbu",
    title: "学园异能部",
    author: "桃色风暴",
    cover: "https://readdy.ai/api/search-image?query=school%20manga%20cover%20of%20five%20high%20school%20students%20with%20different%20colorful%20superpowers%20surrounding%20a%20school%20gate%2C%20bright%20and%20playful%20palette%20with%20sparkles%2C%20energetic%20shonen%20school%20life%20comedy%2C%20dynamic%20group%20pose%2C%20vivid%20anime%20style&width=440&height=600&seq=comic-yineng&orientation=portrait",
    status: "连载中",
    categories: ["校园恋爱", "奇幻异能"],
    tags: ["校园", "超能力", "青春"],
    rating: 8.4,
    views: "612.9万",
    favorites: "22.5万",
    description: "一所看似普通的高中，却藏着一个由异能学生组成的特别社团。笨拙又热血的社长、毒舌的天才、内向的治愈系……一群性格迥异的少年少女，在守护校园与日常的同时，也守护着彼此最珍贵的青春时光。",
    latestChapter: "第163话 社团文化祭",
    updateTime: "7小时前",
    totalChapters: "163话",
    chapters: [
      { num: 163, title: "社团文化祭", updateTime: "7小时前", readCount: 68940 },
      { num: 162, title: "隔壁的转学生", updateTime: "昨天", readCount: 64230 },
      { num: 161, title: "运动会风波", updateTime: "3天前", readCount: 61780 },
      { num: 160, title: "秘密基地", updateTime: "5天前", readCount: 59340 },
    ],
  },
  {
    id: "tieqi-jianghu",
    title: "铁骑江湖",
    author: "狂飙画社",
    cover: "https://readdy.ai/api/search-image?query=manga%20cover%20of%20a%20young%20biker%20on%20a%20custom%20motorcycle%20racing%20through%20a%20dusty%20mountain%20road%2C%20roaring%20engine%20and%20speed%20lines%2C%20deep%20red%20and%20charcoal%20palette%2C%20rebellious%20youth%20road%20story%2C%20raw%20dynamic%20action%20style%2C%20gritty%20adventure&width=440&height=600&seq=comic-tieqi&orientation=portrait",
    status: "连载中",
    categories: ["热血冒险", "都市生活"],
    tags: ["机车", "公路", "热血"],
    rating: 8.3,
    views: "398.4万",
    favorites: "14.2万",
    description: "被城市束缚的少年阿禾，骑上亡父留下的改装机车踏上环山公路。沿途中，他遇到形形色色的旅人，也渐渐理解了什么是自由与责任。在铁与火的轰鸣中，一段属于少年们的江湖故事徐徐展开。",
    latestChapter: "第57话 山道的风",
    updateTime: "9小时前",
    totalChapters: "57话",
    chapters: [
      { num: 57, title: "山道的风", updateTime: "9小时前", readCount: 43120 },
      { num: 56, title: "旧车场", updateTime: "昨天", readCount: 40870 },
      { num: 55, title: "深夜加油站", updateTime: "4天前", readCount: 38290 },
      { num: 54, title: "远方的信", updateTime: "6天前", readCount: 36140 },
    ],
  },
  {
    id: "shenhai-huixiang",
    title: "深海回响",
    author: "蓝鲸之梦",
    cover: "https://readdy.ai/api/search-image?query=underwater%20manga%20cover%20of%20a%20diver%20swimming%20beside%20a%20giant%20gentle%20whale%20in%20deep%20blue%20ocean%2C%20bioluminescent%20plankton%20glowing%2C%20mystical%20and%20serene%20atmosphere%2C%20cool%20cyan%20and%20deep%20navy%20palette%2C%20ethereal%20fantasy%20adventure%20style&width=440&height=600&seq=comic-shenhai&orientation=portrait",
    status: "新上架",
    categories: ["科幻机甲", "悬疑推理"],
    tags: ["深海", "探索", "神秘"],
    rating: 8.8,
    views: "7.2万",
    favorites: "0.6万",
    description: "海洋深处传来一阵神秘的「回响」，让整个深潜科考队陷入迷局。年轻的海洋学者沈蓝随队深入马里亚纳海沟，探寻回响的源头。在无尽深蓝之中，等待他们的不仅是未知生物，更是一段被淹没的历史。",
    latestChapter: "第5话 深海来信",
    updateTime: "1小时前",
    totalChapters: "5话",
    isNew: true,
    chapters: [
      { num: 5, title: "深海来信", updateTime: "1小时前", readCount: 4830 },
      { num: 4, title: "海沟之下", updateTime: "昨天", readCount: 4520 },
      { num: 3, title: "发光的信号", updateTime: "3天前", readCount: 4210 },
      { num: 2, title: "潜入深渊", updateTime: "5天前", readCount: 3980 },
    ],
  },
  {
    id: "chunri-gaobai",
    title: "春日告白",
    author: "樱花糖",
    cover: "https://readdy.ai/api/search-image?query=romance%20manga%20cover%20of%20a%20shy%20couple%20under%20a%20cherry%20blossom%20tree%2C%20falling%20petals%20and%20soft%20sunlight%2C%20gentle%20pink%20and%20cream%20palette%2C%20tender%20sweet%20youth%20romance%20style%2C%20clean%20soft%20lineart%2C%20heartwarming%20atmosphere&width=440&height=600&seq=comic-chunri&orientation=portrait",
    status: "连载中",
    categories: ["校园恋爱", "萌系日常"],
    tags: ["纯爱", "青春", "治愈"],
    rating: 8.7,
    views: "788.6万",
    favorites: "30.1万",
    description: "高中最后一个春天，性格内向的转学生向野遇见了总是挂着笑容的同桌小樱。一段小心翼翼又满含期待的心动，在樱花纷飞的季节里悄然萌芽。那些没说出口的话，都藏在春日的风里。",
    latestChapter: "第89话 盛开的樱花",
    updateTime: "5小时前",
    totalChapters: "89话",
    chapters: [
      { num: 89, title: "盛开的樱花", updateTime: "5小时前", readCount: 92340 },
      { num: 88, title: "犹豫的告白", updateTime: "昨天", readCount: 89760 },
      { num: 87, title: "同桌的距离", updateTime: "3天前", readCount: 85210 },
      { num: 86, title: "春天的邀请", updateTime: "5天前", readCount: 82340 },
    ],
  },
];

export const todayUpdates: { comicId: string; chapterTitle: string; time: string }[] = [
  { comicId: "shijian-lvguan", chapterTitle: "第12话 逆流的信", time: "刚刚" },
  { comicId: "jiajia-jiyuan", chapterTitle: "第208话 最后的防线", time: "1小时前" },
  { comicId: "shenhai-huixiang", chapterTitle: "第5话 深海来信", time: "1小时前" },
  { comicId: "xinggui-shaonian", chapterTitle: "第186话 星门彼岸", time: "2小时前" },
  { comicId: "shanhai-shitang", chapterTitle: "第8话 饕餮的胃口", time: "2小时前" },
  { comicId: "xingji-kuadiyuan", chapterTitle: "第152话 银河大促", time: "3小时前" },
  { comicId: "shenyu-zhengtu", chapterTitle: "第176话 神域的黄昏", time: "4小时前" },
  { comicId: "jianqi-changge", chapterTitle: "第142话 剑心明镜", time: "5小时前" },
  { comicId: "chunri-gaobai", chapterTitle: "第89话 盛开的樱花", time: "5小时前" },
  { comicId: "weilei-zhanji", chapterTitle: "第78话 家乡的味道", time: "6小时前" },
  { comicId: "xueyuan-yinengbu", chapterTitle: "第163话 社团文化祭", time: "7小时前" },
  { comicId: "dushi-yexing", chapterTitle: "第94话 霓虹下的真相", time: "8小时前" },
  { comicId: "tieqi-jianghu", chapterTitle: "第57话 山道的风", time: "9小时前" },
];

export const getComicById = (id: string) => comics.find((c) => c.id === id);